import { ConfirmSignUp } from 'aws-amplify-react';
import React from 'react';
import Button from '../Button';
import ContainerDefault from '../Container';
import Form from '../Form';
import Row from '../Row';
import Section from '../Section';
import Explanation from './Explanation';

const Container = ContainerDefault.extend`
    max-width: 20rem;
    position: relative;
`;

const help = {
    head: 'Confirm mobile phone',
    text:
        'Your account was successfully created. We sent an SMS to your mobile phone to make sure that it is valid. Please enter the code that you just received from the sender VSPONSE.'
};

export default class CustomConfirmSignUp extends ConfirmSignUp {
    constructor(props) {
        super(props);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    private onKeyPress(e) {
        if (e.key === 'Enter') {
            this.confirm();
        }
    }

    public render() {
        const { authState } = this.props;

        if (authState !== 'confirmSignUp') {
            return null;
        }

        return (
            <Section>
                <Container>
                    <Form>
                        <h3>Confirm Sign Up</h3>
                        <input
                            autoFocus
                            placeholder="Code"
                            key="code"
                            name="code"
                            autoComplete="off"
                            onChange={this.handleInputChange}
                            onKeyPress={this.onKeyPress}
                        />
                        <Button onClick={this.confirm}>Confirm</Button>
                        <Button onClick={this.resend}>Resend Code</Button>
                    </Form>
                    <Row>
                        <Button normal onClick={() => this.changeState('signIn', undefined)}>
                            Back to Sign In
                        </Button>
                    </Row>
                    <Explanation help={help} />
                </Container>
            </Section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cognito/CustomConfirmSignUp.tsx